<h1 mat-dialog-title>Patient details changed</h1>

<div mat-dialog-content class="irv">
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

    <div class="irv-alert irv-alert--error" *ngIf="loadError">
        <mat-icon>error_outline</mat-icon>
        <div>{{ loadError }}</div>
    </div>

    <ng-container *ngIf="proposal">
        <p class="irv-intro" *ngIf="data.source === 'patient-app'">{{ data.patientName || 'The patient' }} changed their details in the
            patient app on {{ proposal.createdAt | date: 'd MMM y' }}. Accept the changes you want in your practice's record.</p>
        <p class="irv-intro" *ngIf="data.source !== 'patient-app'">{{ proposal.senderPracticeName }} changed {{ data.patientName || "this patient's" }} details on
            {{ proposal.createdAt | date: 'd MMM y' }}. Accept the changes you want in your practice's record.</p>

        <div class="irv-alert" *ngIf="proposal.status !== 'pending'">
            <mat-icon>{{ proposal.status === 'resolved' ? 'check_circle' : 'update' }}</mat-icon>
            <div>{{ proposal.status === 'resolved' ? 'Already reviewed' : 'A newer change replaced this one' }}</div>
        </div>

        <div class="irv-toolbar" *ngIf="proposal.status === 'pending'">
            <span class="irv-toolbar__summary" data-test="summary">{{ summary }}</span>
            <span class="irv-toolbar__bulk" *ngIf="proposal.fields.length">
                <button mat-button type="button" color="primary" (click)="setAll('accept')">Accept all</button>
                <button mat-button type="button" (click)="setAll('reject')">Reject all</button>
            </span>
        </div>

        <div data-test="fields">
            <section class="irv-section" *ngFor="let g of groups">
                <h3 class="irv-section__title">{{ g.section }}</h3>
                <div class="irv-row" *ngFor="let f of g.fields" data-test="field"
                     [class.irv-row--missing]="submitAttempted && proposal.status === 'pending' && needsDecision(f)">
                    <div class="irv-row__body">
                        <div class="irv-row__label">{{ f.label }}</div>
                        <div class="irv-row__change">
                            <span class="irv-row__old">{{ value(f.old) }}</span>
                            <mat-icon class="irv-row__arrow" aria-hidden="true">arrow_forward</mat-icon>
                            <span class="irv-row__new">{{ value(f.proposed) }}</span>
                        </div>
                        <div class="irv-row__record" *ngIf="differsFromRecord(f)">In your record: {{ value(f.current) }}</div>
                    </div>
                    <div class="irv-row__control">
                        <span class="irv-chip" *ngIf="f.alreadySame && proposal.status === 'pending'"><mat-icon>check</mat-icon>Already the same</span>
                        <mat-button-toggle-group *ngIf="!f.alreadySame && proposal.status === 'pending'" class="irv-toggle"
                                                 [(ngModel)]="decisions[f.field]" [attr.aria-label]="f.label">
                            <mat-button-toggle class="irv-toggle__yes" value="accept">Accept</mat-button-toggle>
                            <mat-button-toggle class="irv-toggle__no" value="reject">Reject</mat-button-toggle>
                        </mat-button-toggle-group>
                        <span *ngIf="proposal.status !== 'pending' && proposal.decisions?.[f.field] as d" class="irv-chip"
                              [class.irv-chip--yes]="d === 'accepted'" [class.irv-chip--no]="d === 'rejected'">{{ outcomeLabels[d] || d }}</span>
                    </div>
                </div>
            </section>
        </div>

        <ng-container *ngIf="proposal.status === 'pending'">
            <div class="irv-alert irv-alert--warning" *ngIf="warning" data-test="warning">
                <mat-icon>warning_amber</mat-icon>
                <div>{{ warning }}</div>
            </div>
            <div class="irv-alert irv-alert--warning" *ngIf="submitAttempted && undecided.length" data-test="undecided">
                <mat-icon>rule</mat-icon>
                <div>Decide {{ undecided.length }} more {{ undecided.length === 1 ? 'change' : 'changes' }} before saving.</div>
            </div>
        </ng-container>

        <div class="irv-alert irv-alert--error" *ngIf="actionError">
            <mat-icon>error_outline</mat-icon>
            <div>{{ actionError }}</div>
        </div>
    </ng-container>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="close()" [disabled]="isSaving">Close</button>
    <button mat-flat-button color="primary" *ngIf="proposal?.status === 'pending'" (click)="save()" [disabled]="isSaving" data-test="save">
        {{ isSaving ? 'Saving…' : 'Save decisions' }}
    </button>
</div>
